
import { useDispatch } from "react-redux";
import { getDepartmentsStart } from "../../../../../redux/departments/reducer";
import useDepartmentEditor from "../../../../../hooks/departments/useDepartmentsEditor";
import styled from "styled-components";
import { Text, DropDown } from "@flexisaf/flexibull2";
import Theme from "../../../../../theme";

const DepartmentCard = ({ name, id, handleEdit }) => {
  const {deleteDepartment} = useDepartmentEditor()
  const dispatch = useDispatch();
  const handleDelete = (id) => {
    let payload = {
    id,
      callback: () => {
      dispatch(getDepartmentsStart())
      },
    };
    deleteDepartment(payload)
  };
  return (
    <DeparmentCardContainer>
      <div className="card-header">
        <DropDown
          label={
            <Text bold size="14px" style={{ cursor: "pointer" }}>
              ...
            </Text>
          }
          className="dropdown"
          menuAlign="bottom right"
          trigger="click"
          menuList={[
            {
              onClick: () => handleEdit(id, name),
              label: "Edit Deparment",
              iconLeft: "saf-receipt-edit",
            },
            {
              onClick: () => handleDelete(id),
              label: "Delete Department",
              color: Theme.PrimaryRed,
              iconLeft: "saf-trash",
            },
          ]}
        />
      </div>

      <div className="card-body">
        <Text size="16px" bold color={Theme.PrimaryGrey}>
          {name}
        </Text>
      </div>
    </DeparmentCardContainer>
  );
};

export default DepartmentCard;

const DeparmentCardContainer = styled.div`
  background: #f1f1f17d;
  border-radius: 8px;

  & .card-header {
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1rem;
    & .dropdown {
    margin-left: auto;
    }
  }
  & .card-body {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 2rem 1rem;
    height: 10rem;
    & p > span {
      font-weight: bold;
    }
  }
  & .card-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
    padding: 1rem 0;
  }
  & .topics {
    padding: 0.5rem 1rem;
  }
`;
